import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useToggle } from '../../../../../../hooks/use-toggle';
import { RoleType } from '../../../../../../store/api/role-api';

export interface RolesDictionaryGroupedProps {
  role: RoleType;
  isSystem?: boolean;
}

export const useRolesDictionaryGrouped = ({ role, isSystem }: RolesDictionaryGroupedProps) => {
  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();
  const [collapse, toggleCollapse] = useToggle();
  const [tooltip, , setTooltip] = useToggle();

  const count = role.employees?.length || 0;

  const handleDeleteRole = (e: React.MouseEvent) => {
    e.stopPropagation();
    setTooltip(false);
    addQueryParams({ deletePrefix: 'role', deleteId: role.id, deleteName: role.name });
  };

  const createRoleModal = useModalParams('createRole');
  const unattachRoleModal = useModalParams('unattachRole');

  const handleEditRole = (e: React.MouseEvent) => {
    e.stopPropagation();
    setTooltip(false);
    createRoleModal.handleOpenModal({ roleId: role.id, isSystem: isSystem ? 'true' : '' });
  };

  return {
    t,
    getLocale,
    collapse,
    toggleCollapse,
    tooltip,
    setTooltip,
    count,
    handleDeleteRole,
    handleEditRole,
    unattachRoleModal,
  };
};
